import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-search\"><g fill=\"none\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"1.5\"><path d=\"m16.4 16.7 6.3 6.5\" /><ellipse cx=\"10.5\" cy=\"9.8\" rx=\"9.2\" ry=\"9.1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol